import { useOutletContext } from 'react-router-dom';
import { useAppSelector } from 'config/hooks';
import { useDeclarationContext } from 'views/declarations/common/DeclarationContext';
import { isNonAmendableField } from './nonAmendableFields';

const useNonAmendableField = (path: string | undefined) => {
    const outletContext = useOutletContext<{ amendment?: boolean }>();
    // Selected straight from the store rather than through useDeclarations: this runs in every field
    // of the form, and that hook builds more than fifty callbacks and half a dozen subscriptions per
    // call. Only the declaration is needed here.
    const declaration = useAppSelector((state) => state.declarations.declaration);
    const { form } = useDeclarationContext();

    if (!outletContext?.amendment) return false;

    return isNonAmendableField(declaration, form, path);
};

export default useNonAmendableField;
